/* eslint react/no-danger: "off" */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { parseCssExports } from 'utils/commonUtils';
import { parse, init } from 'utils/twitter';

const twitterTags = parseCssExports(require('./EmbeddedTweet.scss'), {prefix: "embedded-tweet", transform: i=>i});

export default class EmbeddedTweet extends Component {
  static propTypes = {
    html: PropTypes.string
  };

  componentDidUpdate() {
    parse(this.el);
  }

  componentDidMount(){
    init();
    parse(this.el);
  }

  render(){
    const helmetProps = {
      meta: []
    };

    Object.keys(twitterTags).forEach(name => {
      helmetProps.meta.push({
        name: `twitter:widgets:${name}`,
        content: twitterTags[name]
      });
    });


    // Seems Twitter replaces the node, and this annoys React, so dangerouslySetInnerHTML to the rescue
    return <div className="embedded-tweet">
      <Helmet {...helmetProps}/>
      <div
        ref={el => {this.el = el}}
        dangerouslySetInnerHTML={{__html: this.props.html}}
      />
    </div>;
  }
}




// WEBPACK FOOTER //
// ./modules/Common/components/EmbeddedTweet.js